export default __webpack_public_path__ + "static/media/menubar.a1792154.svg";